/**
 * Config API endpoint
 */

import { api } from '../client';
import type { AppConfigResponse } from '../types';
import { AppConfigResponseSchema } from '../schemas';
import { parseResponse } from '../validation';

export const configApi = {
  /**
   * Fetch app configuration.
   *
   * NO FALLBACK: a network failure or a schema-validation failure both
   * propagate to the caller. There used to be a hardcoded FALLBACK_CONFIG
   * substituted on ANY failure — indistinguishable from a real backend
   * response, so the store marked isConfigLoaded:true and the whole app ran
   * silently on stale English-only defaults with `org.self_assign` absent.
   * useConfigLoader is the caller that turns a thrown error here into a
   * visible error state (ConfigErrorScreen via App.tsx's route guards) —
   * real data or a visible error with retry, never a fabricated default.
   */
  getConfig: async (): Promise<AppConfigResponse> => {
    const res = await api.get('/config');
    return parseResponse(AppConfigResponseSchema, res, 'GET /config');
  },
};
